import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import { convertUrl } from '~/services/util';

const BlogItem = ({ author, description, logo, name, thumb, type, stats, comments, createAt, onClick }) => {
    const url = convertUrl(logo);
    const authorTitle = author?.profile?.company || 'DealerSocket';
    const authorName = author?.first_name ? `${author?.first_name} ${author?.last_name}` : 'Tina Bolboa';
    const UserId = useSelector((state) => state.app.user.community_user_id);
    return (
        <div className={`vendor-search-blogs-item ${type}`} onClick={onClick}>
            {type === 'simple' ? (
                <Row className="mx-0">
                    <Col className="px-0" xs={3}>
                        {thumb && thumb.match(/<img/) ? <div className="blog-image" dangerouslySetInnerHTML={{ __html: thumb }} /> : <Thumbnail source={convertUrl(thumb)} size="tiny" />}
                    </Col>
                    <Col className="px-0" xs={9}>
                        <p className="dsl-b16 mb-1">{name}</p>
                        <p className="dsl-b12 mb-1">{`By: ${authorName}`}</p>
                        <div className="d-h-start">
                            <Icon name="far fa-eye" size={12} />
                            <p className="dsl-m12 mb-0 ms-1 me-4">{stats.views}</p>
                            <Icon name="far fa-thumbs-up" size={12} color={stats?.liked && UserId && stats?.liked[UserId] ? '#376caf' : '#969faa'} />
                            <p className={cx('dsl-m12 mb-0 ms-1 me-4', stats?.liked && UserId && stats?.liked[UserId] && 'text-primary text-400')}>{stats.likes}</p>
                            <Icon name="fas fa-comment" size={12} color={comments.some((comment) => comment.user_id === UserId) ? '#376caf' : '#969faa'} />
                            <p className={cx('dsl-m12 mb-0 ms-1', comments.some((comment) => comment.user_id === UserId) && 'text-primary text-400')}>{stats.comments}</p>
                        </div>
                    </Col>
                </Row>
            ) : (
                <Row className="mx-0">
                    <Col className="px-0" xs={3} md={2}>
                        {thumb && thumb.match(/<img/) ? <div className="blog-image" dangerouslySetInnerHTML={{ __html: thumb }} /> : <Thumbnail source={convertUrl(thumb)} size="tiny" />}
                    </Col>
                    <Col className="px-0" xs={8} md={9}>
                        <p className="dsl-b14 bold mb-2">{name}</p>
                        <div className="dsl-b14 truncate-two mb-2" dangerouslySetInnerHTML={{ __html: description }} />
                        <div className="d-h-start">
                            <Avatar url={url} type="logo" size="extraTiny" borderColor="#969faa" />
                            <div className="ml-3">
                                <p className="dsl-m12 mb-1">{authorName}</p>
                                <p className="dsl-m12 mb-0">{authorTitle}</p>
                            </div>
                        </div>
                    </Col>
                    <Col className="px-0 d-h-end flex-column" xs={1}>
                        <p className="dsl-b12 my-3">{moment(createAt).format('MMM DD, YY')}</p>
                    </Col>
                </Row>
            )}
        </div>
    );
};

BlogItem.propTypes = {
    author: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        profile: PropTypes.shape({ company: PropTypes.string }),
    }),
    createAt: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    name: PropTypes.string,
    thumb: PropTypes.string,
    type: PropTypes.oneOf(['simple', 'detail']),
    stats: PropTypes.shape({
        comments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dislikes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        like_avg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        likes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        views: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    onClick: PropTypes.func,
};

BlogItem.defaultProps = {
    author: null,
    createAt: '',
    description: '',
    logo: null,
    name: '',
    thumb: null,
    type: 'simple',
    stats: {
        comments: '',
        dislikes: 0,
        like_avg: '',
        likes: '',
        views: '',
    },
    onClick: () => {},
};

export default memo(BlogItem);
